import { Grid } from '@mui/material'
import { FormField } from 'global/components/Form'
import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { SubmitHandler } from 'react-hook-form'
import { useParams } from 'react-router-dom'
import { AvaliacaoSchema, funcionario } from 'service/api'
import { toast } from 'sonner'
import { z } from 'zod'

const schema = z
    .object({
        senha: AvaliacaoSchema.shape.senha,
        confirmar: AvaliacaoSchema.shape.confirme,
    })
    .refine(data => data.senha === data.confirmar, {
        message: 'As senhas não coincidem',
        path: ['confirmar'],
    })

export default function AlterarSenhaFuncionario() {
    const { funcionarioId } = useParams()

    if (!funcionarioId) return null

    const handleSubmit: SubmitHandler<z.infer<typeof schema>> = async data =>
        funcionario
            .post<unknown>(`${funcionarioId}/alterar-senha`, data)
            .then(() => toast.success('Senha alterada com sucesso'))
            .catch(e => {
                toast.error(e.message)
                throw e
            })

    return (
        <Dialog.Root
            onSubmit={handleSubmit}
            schema={schema}
            height="auto"
            width="29rem"
            open={hasPermission(['update', 'Funcionários'])}
        >
            <Dialog.Title>Alterar senha</Dialog.Title>
            <Dialog.Content dividers>
                <Grid container rowGap={0.5}>
                    <Grid item xs={12}>
                        <FormField
                            fullWidth
                            name="senha"
                            label="Senha"
                            hiddenPassword
                            required
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormField
                            fullWidth
                            name="confirmar"
                            label="Confirmar senha"
                            hiddenPassword
                            required
                        />
                    </Grid>
                </Grid>
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
